import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface Property {
  id: string;
  title: string;
  link: string;
  price: number;
  ownerId: string;
}

interface PropertySelectProps {
  properties: Property[];
  ownerId: string;
  value: string;
  onChange: (value: string) => void;
}

export const PropertySelect = ({ properties, ownerId, value, onChange }: PropertySelectProps) => (
  <div className="space-y-2">
    <label className="text-sm font-medium">Imóvel</label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger>
        <SelectValue placeholder="Selecione um imóvel" />
      </SelectTrigger>
      <SelectContent>
        {properties
          .filter(property => property.ownerId === ownerId)
          .map((property) => (
            <SelectItem key={property.id} value={property.id}>
              {property.title}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  </div>
);